import validate from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@types+node@25.9.2_@vue+compiler-sfc@3.5.35_cac@6.7.1_7fea3f506792a1e7fbb51c8db1c410e9/node_modules/nuxt/dist/pages/runtime/validate.js";
import device_45global from "/nuxtWeb/middleware/device.global.ts";
import legacy_45user_45center_45redirect_45global from "/nuxtWeb/middleware/legacy-user-center-redirect.global.ts";
import user_45center_45auth_45global from "/nuxtWeb/middleware/user-center-auth.global.ts";
import manifest_45route_45rule from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@types+node@25.9.2_@vue+compiler-sfc@3.5.35_cac@6.7.1_7fea3f506792a1e7fbb51c8db1c410e9/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  device_45global,
  legacy_45user_45center_45redirect_45global,
  user_45center_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}